module.exports = __webpack_public_path__ + "img/mickey103.f565ff9a.jpg";